import { GraphQL } from "@rpi/openapi-api";
import React from "react";
import { AccountSettingsCard } from "./AccountSettingsCard";
import { DAILY_ORDER_LIMIT_TOOLTIP, EMPTY_FIELD_PLACEHOLDER, QUEUED_ORDER_LIMIT_TOOLTIP } from "./accountSettingsCopy";
import { FieldRow } from "./FieldRow";
import { LabeledField } from "./LabeledField";
import { TaxExemptionSection } from "./TaxExemptionSection";
import { TaxExemptionDocument } from "./TaxDocumentRow";

function formatLimit(value?: number): string {
  return typeof value === "number" ? value.toLocaleString() : EMPTY_FIELD_PLACEHOLDER;
}

interface OrderCardProps {
  maxOrders?: number;
  limitQueueSize?: number;
  showTaxExemption: boolean;
  taxDocuments: TaxExemptionDocument[];
  taxReviewStatus?: GraphQL.TaxReviewStatus | null;
  onUploadTaxExempt: () => void;
}

export const OrderCard: React.FC<OrderCardProps> = ({
  maxOrders,
  limitQueueSize,
  showTaxExemption,
  taxDocuments,
  taxReviewStatus,
  onUploadTaxExempt,
}) => {
  return (
    <AccountSettingsCard title="Order" data-testid="order-card">
      <FieldRow>
        <LabeledField
          label="Daily Order Limit"
          value={formatLimit(maxOrders)}
          tooltip={DAILY_ORDER_LIMIT_TOOLTIP}
          testId="order-daily-limit"
        />
        <LabeledField
          label="Queued Order Limit"
          value={formatLimit(limitQueueSize)}
          tooltip={QUEUED_ORDER_LIMIT_TOOLTIP}
          testId="order-queued-limit"
        />
      </FieldRow>

      {showTaxExemption && (
        <TaxExemptionSection documents={taxDocuments} reviewStatus={taxReviewStatus} onUpload={onUploadTaxExempt} />
      )}
    </AccountSettingsCard>
  );
};
